const config = {
  version: '2.8.0',
  type: 'js'
};

export default config;


// WEBPACK FOOTER //
// ./src/config.ts